import { encodedStringParser } from '../inboundParsers';
export const EXIT_MTT_STAGING_TO_LOBBY_PAYLOAD_DEFINITION = {
    definitionParts: [{ name: 'loadingRoomMessage', parser: encodedStringParser }]
};
